<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
          <strong> Manage Pallet</strong> 
          <!-- <div class="card-header-actions" > -->
              <!-- <router-link
        to="/LineHaulPalletlisting">
             <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="addapllet()"  type="button">Line Haul Pallet</button>   
             </router-link>   -->          
            <!--   <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="addapllet()"  type="button">Add New Pallets</button> 
                <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button> 
            </div> -->
          </div>

          <!-- <div id="addapllet"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-row> 
                  <b-col md="12">
                    <div class="form-group row">
                       <label class="col-md-3 col-form-label" for="hf-email">Pallet Name</label>
                      <div class="col-md-4">
                        <b-form-input class="form-control" type="text" name="palletname" v-model="palletname" v-validate="'required|'"placeholder="Enter Pallet Name" :class="{'input': true, 'text-danger': errors.has('form-1.palletname') }"  >
                       </b-form-input>
                       <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('palletname')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.palletname')" class="help text-danger">{{ errors.first('form-1.palletname') }}</span>
                      </b-input-group>
                      </div>
                
                    </div>   
                   
              
                                          
                  </b-col>
                
                  <b-col sm="4">
                    
                    <b-button  variant="primary" size="md" type="submit">Save</b-button>&nbsp;&nbsp;&nbsp;
                    <b-button variant="primary" size="md"  @click="addclear">Clear</b-button>
                  </b-col>
                   
                 
                </b-row>  
              </b-form>
          </div> -->

          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
              <li class="nav-item">
                <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Normal Pallet</a>
              </li>
            
              <li class="nav-item" v-if="userCountry == 'KSA'">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >HubtoHub Pallet</a>
              </li>

              <li class="nav-item" v-if="userCountry == 'KSA'">
                <a @click="activeTab = 2"  class="nav-link" :class="{'active' : isActiveTab(2)}" >Miss Route Pallet</a>
              </li>
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
        
            <div class="tab-panel" v-if="isActiveTab(0)">
              <manageNormalpallet style="width:70%;"></manageNormalpallet>
            </div>

            <div class="tab-panel" v-if="isActiveTab(1)">
            <manageHubpallet style="width:70%;"></manageHubpallet>
            </div>
            
            <div class="tab-panel" v-if="isActiveTab(2)">
              <missroutepallet style="width:70%;"></missroutepallet>
              </div>
             </b-col>
          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   

<!-- </notassigned-component> -->
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import manageNormalpallet from './manageNormalpallet.vue'
// import PickCancel_mr from './pickCancel_mr.vue'
import manageHubpallet from './manageHubpallet.vue'
import missroutepallet from './missroutepallet.vue'

export default {
  data: function() {
    return {
      activeTab: 0,
     manageNormalpallet,
     manageHubpallet,
     missroutepallet,
     palletname:'',
      id:'',
     userCountry:'',
     
    };
  },
  components: {
   manageNormalpallet,
   manageHubpallet,
   missroutepallet,
  },
  created: function() {
    var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    this.userCountry = userInfo.country;
    console.log("Country",this.userCountry);
    this.isActiveTab(0);
  },
  methods: {
    isActiveTab(id)
    {
       return this.activeTab === id
    },
    //     addapllet: function() {
    //   this.errors.clear("form-1");
   
    //   // var allocatepin = document.getElementById('allocatepin')
    //   // allocatepin.style.display = 'none'
    //   var addpallet = document.getElementById("addapllet");
    //   addpallet.style.display = "block";
    
    // },
    //  getactiveTab: function() {
    //   // alert("innn");
    // var activeTab='';
    // // var activetabcount='';

    // // var vehicleid_from=  document.getElementById('vechicle_from').value;

     
     

    //       if (this.activeTab==1) {

    //         this.activeTab=1;
    //         this.isActiveTab(activeTab);

    //       }
    //       else
    //       {
    //         // alert("000");
    //         this.activeTab=0;
    //         this.isActiveTab(activeTab);
    //       }
       
    // },
    validateForm(scope) {
       this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addpalletinfo();
        }
      });
    },
 //    addpalletinfo: function() {
 //     var userdata = localStorage.getItem('userData')
 //      var userInfo = JSON.parse(userdata)


 //     const palletsave = {
                
            
 //                 pallet_title:this.palletname,
 //                 created_by:`${userInfo.sysemailid}`,
 //                  hub_id:`${userInfo.pickuplocationmasterid}`,
                 
                 
 // }

 //      console.log(palletsave);
 //      return false;
 //    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/addnewpallet`,palletsave)
 //        .then((result) => {
 //         if (result.body.returnmsg === "Successful") {
 //                 // Utils.notify("Added successfully", "success");
 //                  this.$fire({
 //                  text:"Added Successfully",
 //                  type: "success",
 //                  timer: 30000
 //                }); 
 //                 this.isActiveTab(0);
 //                  this.clear();
                 
 //                  // this.displaydata();

 //                  this.$router.push('/managePallets');
 //                } else {
 //            // Utils.notify(result.body.returnvalue);
 //            this.$fire({
 //                  text:result.body.returnvalue,
 //                  type: "error",
 //                  timer: 30000
 //                }); 
 //          }
 //        })
 //        .catch((ex) => {
 //          console.log('error-----', ex)
 //        })
      
 //    },
   
    refresh:function() {
     
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addpallet = document.getElementById("addapllet");
      addpallet.style.display = "none";
      this.clear();
    },
    clear: function() {
      this.palletname="";
      
      this.errors.clear('form-1')    
    }    
  }
};
</script>